import _createForOfIteratorHelper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _get from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module ui/colorgrid/colorgridview
 */
import View from '../view.js';
import ColorTileView from './colortileview.js';
import addKeyboardHandlingForGrid from '../bindings/addkeyboardhandlingforgrid.js';
import { FocusTracker, KeystrokeHandler } from '@ckeditor/ckeditor5-utils';
import '../../theme/components/colorgrid/colorgrid.css';
/**
 * A grid of {@link module:ui/colorgrid/colortileview~ColorTileView color tiles}.
 */
var ColorGridView = /*#__PURE__*/function (_View) {
  _inherits(ColorGridView, _View);
  var _super = _createSuper(ColorGridView);
  /**
   * Creates an instance of a color grid containing {@link module:ui/colorgrid/colortileview~ColorTileView tiles}.
   *
   * @fires execute
   * @param locale The localization services instance.
   * @param options Component configuration
   * @param options.colorDefinitions Array with definitions
   * required to create the {@link module:ui/colorgrid/colortileview~ColorTileView tiles}.
   * @param options.columns A number of columns to display the tiles.
   */
  function ColorGridView(locale, options) {
    var _this;
    _classCallCheck(this, ColorGridView);
    _this = _super.call(this, locale);
    var colorDefinitions = options && options.colorDefinitions ? options.colorDefinitions : [];
    _this.columns = options && options.columns ? options.columns : 5;
    var viewStyleAttribute = {
      gridTemplateColumns: "repeat( ".concat(_this.columns, ", 1fr)")
    };
    _this.set('selectedColor', undefined);
    _this.items = _this.createCollection();
    _this.focusTracker = new FocusTracker();
    _this.keystrokes = new KeystrokeHandler();
    _this.items.on('add', function (evt, colorTile) {
      colorTile.isOn = colorTile.color === _this.selectedColor;
    });
    colorDefinitions.forEach(function (color) {
      var colorTile = new ColorTileView();
      colorTile.set({
        color: color.color,
        label: color.label,
        tooltip: true,
        hasBorder: color.options.hasBorder
      });
      colorTile.on('execute', function () {
        _this.fire('execute', {
          value: color.color,
          hasBorder: color.options.hasBorder,
          label: color.label
        });
      });
      _this.items.add(colorTile);
    });
    _this.setTemplate({
      tag: 'div',
      children: _this.items,
      attributes: {
        class: ['ck', 'ck-color-grid'],
        style: viewStyleAttribute
      }
    });
    _this.on('change:selectedColor', function (evt, name, selectedColor) {
      var _iterator = _createForOfIteratorHelper(_this.items),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;
          item.isOn = item.color === selectedColor;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    });
    return _this;
  }
  /**
   * Focuses the first focusable in {@link #items}.
   */
  _createClass(ColorGridView, [{
    key: "focus",
    value: function focus() {
      if (this.items.length) {
        this.items.first.focus();
      }
    }
    /**
     * Focuses the last focusable in {@link #items}.
     */
  }, {
    key: "focusLast",
    value: function focusLast() {
      if (this.items.length) {
        this.items.last.focus();
      }
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      _get(_getPrototypeOf(ColorGridView.prototype), "render", this).call(this);
      // Items added before rendering should be known to the #focusTracker.
      var _iterator2 = _createForOfIteratorHelper(this.items),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var item = _step2.value;
          this.focusTracker.add(item.element);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this.items.on('add', function (evt, item) {
        _this2.focusTracker.add(item.element);
      });
      this.items.on('remove', function (evt, item) {
        _this2.focusTracker.remove(item.element);
      });
      // Start listening for the keystrokes coming from #element.
      this.keystrokes.listenTo(this.element);
      addKeyboardHandlingForGrid({
        keystrokeHandler: this.keystrokes,
        focusTracker: this.focusTracker,
        gridItems: this.items,
        numberOfColumns: this.columns,
        uiLanguageDirection: this.locale && this.locale.uiLanguageDirection
      });
    }
    /**
     * @inheritDoc
     */
  }, {
    key: "destroy",
    value: function destroy() {
      _get(_getPrototypeOf(ColorGridView.prototype), "destroy", this).call(this);
      this.focusTracker.destroy();
      this.keystrokes.destroy();
    }
  }]);
  return ColorGridView;
}(View);
export { ColorGridView as default };